// extracted by mini-css-extract-plugin
export default {"notifications":"ActivityNotifications_notifications__ZvSh1"};